import React from "react";
import styled from "styled-components";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  aptInfoDataList,
  modalState,
  selectLive,
  selectSize,
  selectTab,
} from "../atoms";
import { ReactComponent as ChevronDown } from "../assets/Icon/i-chevronDown.svg";

const Tabs = () => {
  const date = useRecoilValue(selectTab);
  const size = useRecoilValue(selectSize);
  const live = useRecoilValue(selectLive);
  const setModalState = useSetRecoilState(modalState);
  const defaultSize = useRecoilValue(aptInfoDataList);

  return (
    <Container className={"container px-4 pt-4 row"}>
      <ButtonWrapper>
        <Button
          className={
            date === "recent"
              ? "w-100 d-flex flex-row justify-content-around align-items-center py-2 mx-2 bg-white rounded-pill border"
              : "w-100 d-flex flex-row justify-content-around align-items-center py-2 mx-2 rounded-pill border-0 text-primary bg-primary-light"
          }
          onClick={() => setModalState({ state: true, type: "date" })}
        >
          <ButtonText>{date === "all" ? "전체기간" : "최근3년"}</ButtonText>
          <ButtonText>
            <ChevronDown />
          </ButtonText>
        </Button>
      </ButtonWrapper>
      <ButtonWrapper className={"ml-2"}>
        <Button
          className={
            defaultSize[0] && size === defaultSize[0].j_area
              ? "w-100 d-flex flex-row justify-content-around align-items-center py-2 mx-2 bg-white rounded-pill border"
              : "w-100 d-flex flex-row justify-content-around align-items-center py-2 mx-2 rounded-pill border-0 text-primary bg-primary-light"
          }
          onClick={() => setModalState({ state: true, type: "size" })}
        >
          <ButtonText>{size}㎡</ButtonText>
          <ButtonText>
            <ChevronDown />
          </ButtonText>
        </Button>
      </ButtonWrapper>
      <ButtonWrapper className={"ml-2"}>
        <Button
          className={
            live === "m"
              ? "w-100 d-flex flex-row justify-content-around align-items-center py-2 mx-2 bg-white rounded-pill border"
              : "w-100 d-flex flex-row justify-content-around align-items-center py-2 mx-2 rounded-pill border-0 text-primary bg-primary-light"
          }
          onClick={() => setModalState({ state: true, type: "live" })}
        >
          <ButtonText>{live === "m" ? "매매" : "전/월세"}</ButtonText>
          <ButtonText>
            <ChevronDown />
          </ButtonText>
        </Button>
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div``;
const ButtonWrapper = styled.div``;
const Button = styled.button``;
const ButtonText = styled.h5``;

export default Tabs;
